<script lang="ts">
    export let cssClass = ""
</script>

<section class="carousel {cssClass}">
    <slot />
</section>
